module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="bonus-miles-checkbox">\n    <div class="js-bonus-miles-vue-mount"></div>\n    <p class="bonus-miles-filter__description">\n        При покупке тура для участников бонусных программ авиакомпаний возможно начисление миль — только при выборе туроператора Travelata.\n    </p>\n</div>\n';
}
return __p;
};
